export const UPDATE_LIVROS_INSTITUICAO = 'UPDATE_LIVROS_INSTITUICAO'
export const ADD_LIVROS_INSTITUICAO = 'ADD_LIVROS_INSTITUICAO'
export const SET_LIVROS_INSTITUICAO = 'SET_LIVROS_INSTITUICAO'
export const REMOVE_LIVROS_INSTITUICAO = 'REMOVE_LIVROS_INSTITUICAO'
export const SET_LIVRO_INSTITUICAO = 'SET_LIVRO_INSTITUICAO'
export const OPEN_LIVRO_INSTITUICAO = 'OPEN_LIVRO_INSTITUICAO'
export const CLOSE_LIVRO_INSTITUICAO = 'CLOSE_LIVRO_INSTITUICAO'